// ===========================
// Brand Carousel Logos
// ===========================
export const BRAND_LOGOS = {
  butcherBox:
    'https://target.scene7.com/is/image/Target/GUEST_10e94164-64de-4834-8afe-e938768359ee?hei=50&qlt=90',
  crocs:
    'https://target.scene7.com/is/image/Target/GUEST_d4ebf0b2-8682-4701-837f-b1c1fb0205f8?hei=50&qlt=90',
  dh: 'https://target.scene7.com/is/image/Target/GUEST_a50a6df5-4684-41ff-ba43-dd3f58f048b9?hei=50&qlt=90',
  dreamOnMe:
    'https://target.scene7.com/is/image/Target/GUEST_9173507e-cc04-4aea-af1c-72865f0acfd3?hei=50&qlt=90',
  heyDude:
    'https://target.scene7.com/is/image/Target/GUEST_9e314e52-36f5-447a-beee-c5ee732abcbf?hei=50&qlt=90',
  kipling:
    'https://target.scene7.com/is/image/Target/GUEST_e442a3ea-11f5-440e-9f00-68b6c8fcbe0e?hei=50&qlt=90',
  kitchenAid:
    'https://target.scene7.com/is/image/Target/GUEST_a6cf8876-b6f9-4529-a100-c582b97145c8?hei=50&qlt=90',
  kyte: 'https://target.scene7.com/is/image/Target/GUEST_126af298-964b-405b-af81-0f2d2d4b169d?hei=50&qlt=90',
  lampsPlus:
    'https://target.scene7.com/is/image/Target/GUEST_d048c2b5-97e8-4771-8ff2-f6d614cf2f25?hei=50&qlt=90',
  rayban:
    'https://target.scene7.com/is/image/Target/GUEST_b9d11b0e-e9f9-4d73-b962-ee8e062d986c?hei=50&qlt=90',
  reebok:
    'https://target.scene7.com/is/image/Target/GUEST_d2f877b1-269b-4b3b-af57-7e6aaccdbde1?hei=50&qlt=90',
  rossSimons:
    'https://target.scene7.com/is/image/Target/GUEST_0d421984-bd42-43a4-a6b7-255bf9f2ea1a?hei=50&qlt=90',
  songMicHome:
    'https://target.scene7.com/is/image/Target/GUEST_02421cfa-dd35-472b-830f-cd61f7b52270?hei=50&qlt=90',
  timberland:
    'https://target.scene7.com/is/image/Target/GUEST_0828180a-0616-48fd-97e0-a698af430dfa?hei=50&qlt=90',
  veraBradley:
    'https://target.scene7.com/is/image/Target/GUEST_a1bc7b55-52b3-42f6-9686-53eb11723c0d?hei=50&qlt=90',
}

// ===========================
// Channel Partner Logos (old style)
// ===========================
export const CHANNEL_PARTNER_LOGOS = {
  acenda:
    'https://target.scene7.com/is/image/Target/GUEST_25ced9d0-0558-4d6e-8a72-ad69d9be5c37?wid=1000&qlt=90',
  base: 'https://target.scene7.com/is/image/Target/GUEST_93e0382a-9eda-47e8-a055-ea1e31b8b18f',
  channelEngine:
    'https://target.scene7.com/is/image/Target/GUEST_b1ff7dba-3fab-47d1-bc15-6c0fbe0e6c76?wid=1000&qlt=90',
  feedonomics:
    'https://target.scene7.com/is/image/Target/GUEST_7ec50695-1c66-41ff-b697-17aa72081ae7?wid=1000&qlt=90',
  goflow:
    'https://target.scene7.com/is/image/Target/GUEST_48f76259-26e6-4344-9107-8e3011db7192?wid=1000&qlt=90',
  rithum:
    'https://target.scene7.com/is/image/Target/GUEST_6c9a906e-4b0a-4d78-bce4-ad1fccb0c638?wid=1000&qlt=90',
  shopify:
    'https://target.scene7.com/is/image/Target/GUEST_dd529c47-b641-4b55-80f9-2a3ffc92dd14?wid=1000&qlt=90',
  storeAutomator:
    'https://target.scene7.com/is/image/Target/GUEST_296591ba-64c2-44a0-ac3c-068a479e474d',
  zentail:
    'https://target.scene7.com/is/image/Target/GUEST_62356b5a-a194-4bff-9625-03d1036b8409?wid=1000&qlt=90',
  akeneo:
    'https://target.scene7.com/is/image/Target/GUEST_b35d7851-4364-40dd-b3fa-59d75abd4e53',
  rokt: 'https://target.scene7.com/is/image/Target/GUEST_fe48c83d-eb5c-412e-8030-c4b75b498d66',
}

// ===========================
// Partnership / Success Story Cards (Home page)
// ===========================
export const PARTNERSHIP_IMAGES = {
  reebok:
    'https://target.scene7.com/is/image/Target/GUEST_fc97af26-f228-4348-83dd-674cd5fd0107',
  crazydog:
    'https://target.scene7.com/is/image/Target/GUEST_19e50e0f-6d3c-4901-8399-e77711e3f2a5',
  bcp: 'https://target.scene7.com/is/image/Target/GUEST_87bc66e5-511d-4ef9-8e8a-45b1d62f7825',
}

// ===========================
// Hero / Banner Images
// ===========================
export const HERO_IMAGES = {
  howItWorks:
    'https://target.scene7.com/is/image/Target/GUEST_ad621549-9f6c-4aba-99ec-0e41501777f9?wid=1500&qlt=90',
  serviceOfferings:
    'https://target.scene7.com/is/image/Target/GUEST_203dba15-656b-49a0-ab49-6354dea03b23?wid=1500&qlt=90',
}

// ===========================
// Success Stories Grid (thumbnails)
// ===========================
export const STORY_THUMBNAILS = {
  reebok:
    'https://target.scene7.com/is/image/Target/GUEST_8a444bc0-c76e-4d93-af0d-7f1429fe5c90',
  songmicsHome:
    'https://target.scene7.com/is/image/Target/GUEST_03507150-c3da-4992-b0f9-9446a4cf7d0f',
  dreamOnMe:
    'https://target.scene7.com/is/image/Target/GUEST_d80206f1-f2ed-4559-97a8-b52da84c0708',
  verabradley:
    'https://target.scene7.com/is/image/Target/GUEST_9635476e-d5f6-4771-b19b-134712de6d89',
  crazydog:
    'https://target.scene7.com/is/image/Target/GUEST_4c722e2e-cbdf-45a3-b16e-e3cde836daa9',
  bcp: 'https://target.scene7.com/is/image/Target/GUEST_ed431b12-3591-4892-bf1b-314bbe0ee71e',
  rwflame:
    'https://target.scene7.com/is/image/Target/GUEST_8779efd7-c628-4ab4-a8c0-54d9bc775568',
  kinderking:
    'https://target.scene7.com/is/image/Target/GUEST_aa941fff-2b10-45be-9eac-b603b390bd2c',
}

// ===========================
// Case Study Detail (hero images)
// ===========================
export const CASE_STUDY_IMAGES = {
  reebok:
    'https://target.scene7.com/is/image/Target/GUEST_1d389d09-d942-4beb-b914-2fd2090173b4?wid=1000&qlt=90',
  songmicsHome:
    'https://target.scene7.com/is/image/Target/GUEST_408635e9-bbe4-473f-996e-bece1bb5f03c?wid=1000&qlt=90',
  dreamOnMe:
    'https://target.scene7.com/is/image/Target/GUEST_adfa3210-6267-4756-ae49-02229dbf0236?wid=1000&qlt=90',
  verabradley:
    'https://target.scene7.com/is/image/Target/GUEST_4bc266b4-80bc-487b-99a3-233dbb84a858?wid=1000&qlt=90',
  crazydog:
    'https://target.scene7.com/is/image/Target/GUEST_399a92f2-0524-4bb7-8872-8176ce133ff6?wid=1000&qlt=90',
  bcp: 'https://target.scene7.com/is/image/Target/GUEST_b0da0028-7aca-4c16-91a9-7e6030e19879?wid=1000&qlt=90',
  rwflame:
    'https://target.scene7.com/is/image/Target/GUEST_eb76ed36-30de-428a-911d-f5334d52aa17?wid=1000&qlt=90',
  kinderking:
    'https://target.scene7.com/is/image/Target/GUEST_47228850-ab2b-4fde-b860-4957cda83628?wid=1000&qlt=90',
}

// ===========================
// Channel Partner Agency Logos (Providers page)
// ===========================
export const PROVIDER_LOGOS = {
  acenda:
    'https://target.scene7.com/is/image/Target/GUEST_39e284b6-814b-4acf-b3a1-d731423331a1?wid=110&qlt=90',
  akeneo:
    'https://target.scene7.com/is/image/Target/GUEST_d7e1cb3e-c503-44c5-8a12-dc6347c267e3?wid=128&qlt=90',
  base: 'https://target.scene7.com/is/image/Target/GUEST_11f1e80b-89be-41d6-bcc3-24bd16f70517?wid=75&qlt=90',
  channelEngine:
    'https://target.scene7.com/is/image/Target/GUEST_ef91e0b6-0577-4714-b2d9-c5287025cada?wid=168&qlt=90',
  feedonomics:
    'https://target.scene7.com/is/image/Target/GUEST_9372a592-abd2-4fc9-9245-737ba1d755d3?wid=150&qlt=90',
  goflow:
    'https://target.scene7.com/is/image/Target/GUEST_136796e2-accf-4396-bbd5-e293c32ee1ce?wid=135&qlt=90',
  mirakl:
    'https://target.scene7.com/is/image/Target/GUEST_7f87bc28-1e57-49e4-9719-bea01719adba?wid=170&qlt=90',
  rithum:
    'https://target.scene7.com/is/image/Target/GUEST_8ec21b11-8f3d-4445-a17c-86aacda9d5d2?wid=119&qlt=90',
  rokt: 'https://target.scene7.com/is/image/Target/GUEST_ad18713f-b348-4517-a7a3-dd63b85212d8?wid=70&qlt=90',
  shopify:
    'https://target.scene7.com/is/image/Target/GUEST_9b2842c5-b9ec-42c0-96d3-6674af96d401?wid=110&qlt=90',
  storeAutomator:
    'https://target.scene7.com/is/image/Target/GUEST_bb331fc7-1839-4128-8eb2-250f1c6defec?wid=110&qlt=90',
  zentail:
    'https://target.scene7.com/is/image/Target/GUEST_69c3e783-c5e0-441a-99c0-81d699e513ba?wid=85&qlt=90',
  bazaarVoice:
    'https://target.scene7.com/is/image/Target/GUEST_5bc82b2a-6e3c-40c4-97bb-8fb29180fe2c?wid=120&qlt=90',
  salsify:
    'https://target.scene7.com/is/image/Target/GUEST_47ca1d8b-1a5a-4d07-abfb-19d89009d309?wid=155&qlt=90',
  powerReview:
    'https://target.scene7.com/is/image/Target/GUEST_d88f288c-451e-4b24-bc54-2e23a79b98a7?wid=92&qlt=90',
  sozie:
    'https://target.scene7.com/is/image/Target/GUEST_5dcbe47f-5b2a-4f2a-9ed4-b9fd32183328?wid=63&qlt=90',
  storyXpress:
    'https://target.scene7.com/is/image/Target/GUEST_25af0291-b3b3-4e2d-b66a-1ee3e3a57bcc?wid=170&qlt=90',
  syndigo:
    'https://target.scene7.com/is/image/Target/GUEST_88e85714-fde8-4665-a104-515a853bacdb?wid=144&qlt=90',
  wholescale:
    'https://target.scene7.com/is/image/Target/GUEST_bf34c8f6-2c7a-4280-9d37-27c064156ba9?wid=130&qlt=90',
  yotpo:
    'https://target.scene7.com/is/image/Target/GUEST_94479b65-d3bc-4328-8098-fbe44e1d66c6?wid=95&qlt=90',
}
